import { render, staticRenderFns } from "./EventItemOnlyTask.vue?vue&type=template&id=fb5eaca8&"
import script from "./EventItemOnlyTask.vue?vue&type=script&lang=js&"
export * from "./EventItemOnlyTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports